"use client"

import { useQueryClient } from "@tanstack/react-query"
import { Typography } from "@/shared/ui/atoms"
import { CustomButton } from "@/shared/ui/molecules"
import { useGetLocale } from "@/shared/hooks/useGetLocale"
import useIconAction from "@/shared/hooks/useIconAction"

const ERROR_MESSAGES: Record<string, { title: string; button: string }> = {
  ko: {
    title: "페이지를 찾을수없습니다.",
    button: "이전으로",
  },
  en: {
    title: "Page not found",
    button: "Go back",
  },
  cn: {
    title: "页面不存在",
    button: "返回",
  },
  jp: {
    title: "ページが見つかりません",
    button: "戻る",
  },
}

export default function Error({ error }: { error: Error & { digest?: string } }) {
  if (process.env.NODE_ENV === "development") {
    console.error(error)
  }

  const queryClient = useQueryClient()
  const locale = useGetLocale() || "ko"
  const { handleBackRoute } = useIconAction()

  const handleGoBack = () => {
    queryClient.clear()
    handleBackRoute()
  }

  const errorText = ERROR_MESSAGES[locale] || ERROR_MESSAGES.ko
  const title = errorText.title
  const buttonText = errorText.button

  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4">
      <Typography size={20} className="mb-4 font-bold text-center">
        {title}
      </Typography>
      <CustomButton onClick={handleGoBack} className="px-6 py-3 bg-[#6B00D7] rounded-lg">
        <Typography className="text-white font-medium">{buttonText}</Typography>
      </CustomButton>
    </div>
  )
}
